import axiosInstance from "../utils/axiosInstance";

// SUPER-ADMIN — search users for the "specific users" picker.
export async function listBroadcastUsers(params) {
  const { data } = await axiosInstance.get("/super-admin/broadcast/users", {
    params,
  });
  return data?.data ?? [];
}

// SUPER-ADMIN — how many users the current audience would reach (no send).
export async function previewBroadcast(payload) {
  const { data } = await axiosInstance.post(
    "/super-admin/broadcast/preview",
    payload
  );
  return data?.data ?? { recipients: 0 };
}

// SUPER-ADMIN — send a notification to the resolved audience.
export async function sendBroadcast(payload) {
  const { data } = await axiosInstance.post("/super-admin/broadcast", payload);
  return data?.data;
}
